import { createContext, useContext } from 'react';
import { Stage } from 'api/contentworkflow/publishing-board';

export interface StageGateConfig {
    showInconsistencies: boolean;
    showClarifications: boolean;
    requiresInconsistencies: boolean;
    requiresClarifications: boolean;
}

// Fallback when the form is rendered outside the Publishing Board (no stage context):
// both cards visible, nothing gates the move — the pre-gating behavior.
export const defaultStageGateConfig: StageGateConfig = {
    showInconsistencies: true,
    showClarifications: true,
    requiresInconsistencies: false,
    requiresClarifications: false,
};

export function stageGateConfigFromStage(stage: Stage | null | undefined): StageGateConfig {
    if (!stage) {
        return defaultStageGateConfig;
    }

    // A hidden gate keeps its stored Required flag (MI-29861) but never shows and never blocks.
    const showInconsistencies = stage.inconsistency_gate_shown_ind === 'Y';
    const showClarifications = stage.clarification_gate_shown_ind === 'Y';
    return {
        showInconsistencies,
        showClarifications,
        requiresInconsistencies: showInconsistencies && stage.inconsistency_gate_required_ind === 'Y',
        requiresClarifications: showClarifications && stage.clarification_gate_required_ind === 'Y',
    };
}

export const StageGateContext = createContext<StageGateConfig>(defaultStageGateConfig);

export const useStageGateConfig = () => useContext(StageGateContext);
